export default "__VITE_ASSET__CIkWViHC__"